// polyfills
import 'babel-polyfill';
import 'element-closest';
import './polyfill';

import './windowExports';

// source
import './web';

import './configureWeb';
import './configurePartialUpdate';
//import './configureTurbolinks';

// css
import '../css/main.scss';



// WEBPACK FOOTER //
// ./fe/web-gmeinder/src/js/index.js